import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);
export const STAFF_ROLES = ["super_admin", "admin", "program_coordinator", "staff", "instructor", "admissions", "finance"];
export const ROLE_LABELS = {
  super_admin: "Super Admin", admin: "Admin", program_coordinator: "Program Coordinator", staff: "Staff", instructor: "Instructor",
  admissions: "Admissions", finance: "Finance", student: "Student", lead: "Customer / Lead",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    check();
  }, [check]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, logout, check }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const isStaff = (u) => u && STAFF_ROLES.includes(u.role);
export const homeFor = (u) => (isStaff(u) ? "/admin" : "/student");

export function RequireAuth({ staff, any, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (any) return children;
  if (staff && !isStaff(user)) return <Navigate to="/student" replace />;
  if (!staff && isStaff(user)) return <Navigate to="/admin" replace />;
  return children;
}

export const can = (user, roles) => user && (user.role === "super_admin" || roles.includes(user.role));
